export const SESSION_LS_KEY = 'session'
